import React, { Fragment } from 'react';

import PickupOrder from '../../../models/PickupOrder';

import Moment from 'moment';

import style from './ordersDriver.module.css';

interface driverPODateTimeMobileProps {
  order: PickupOrder;
};

const driverPODateTimeMobile = (props: driverPODateTimeMobileProps) => {

  const { order } = props;

  return (
    <Fragment>
    <div className={ style.horizontalLine }></div>

      <div className={ style.flex }>

        <div className={ style.wrapper }>
          <div className={ style.pot }>Pick Up Date:</div>
          <div className={ style.pod }>{ Moment(order.pickup_date).format('DD MMM YYYY').toUpperCase() }</div>
        </div>

        <div className={ style.wrapper }>
          <div className={ style.pot }>Pick Up Time:</div>
          <div className={ style.pod }>{ order.pickup_time? order.pickup_time.replace(/([\d]{2})([\d]{2})/,'$1:$2'): '' }</div>
        </div>

      </div>

      <div className={ style.flex }>

        <div className={ style.wrapper }>
          <div className={ style.pot }>Assigned Dock:</div>
          <div className={ style.pod }>{ order.dock_name ? order.dock_name : 'Dock is not defined yet' }</div>
        </div>

      </div>

      <div className={ style.horizontalLine }></div>
      </Fragment>
  );
}

export default driverPODateTimeMobile;